import { render, staticRenderFns } from "./WirelessSupportSyncSettings.vue?vue&type=template&id=89887ce0&"
import script from "./WirelessSupportSyncSettings.vue?vue&type=script&lang=js&"
export * from "./WirelessSupportSyncSettings.vue?vue&type=script&lang=js&"
import style0 from "./WirelessSupportSyncSettings.vue?vue&type=style&index=0&id=89887ce0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports